"use client";
import AlertDialog from "@/components/DialogBox";
import { createContext, useState } from "react";

const AlertDialogContext = createContext({
  alert: null,
  showAlert: function (alertData: any) {},
  hideAlert: function () {},
});

export function AlertDialogContextProvider({ ...props }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeAlert, setActiveAlert]: any = useState(null);

  function showAlertHandler(alertData: any) {
    setIsOpen(true);
    setActiveAlert(alertData);
  }

  function hideAlertHandler() {
    setIsOpen(false);
    setActiveAlert(null);
  }

  const context = {
    alert: activeAlert,
    showAlert: showAlertHandler,
    hideAlert: hideAlertHandler,
  };

  return (
    <AlertDialogContext.Provider value={context}>
      {activeAlert && <AlertDialog isOpen={isOpen} {...activeAlert} />}
      {props.children}
    </AlertDialogContext.Provider>
  );
}

export default AlertDialogContext;
